<template>
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_16763_30976"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="21"
    >
      <rect y="0.5" width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_16763_30976)">
      <path
        d="M14.75 4.62501V4.62501C15.9236 4.62501 16.875 5.5764 16.875 6.75L16.875 8.26786C16.875 8.3674 16.875 8.41717 16.8679 8.45875C16.8323 8.66824 16.6682 8.83234 16.4588 8.86794C16.4172 8.875 16.3674 8.875 16.2679 8.875L12.625 8.875M14.75 4.62501V4.62501C13.5764 4.62501 12.625 5.5764 12.625 6.75001L12.625 8.875M14.75 4.62501L8.125 4.62501C6.23938 4.62501 5.29657 4.62501 4.71079 5.21079C4.125 5.79658 4.125 6.73939 4.125 8.62501L4.125 17.375L6.25 16.6667L8.375 17.375L10.5 16.6667L12.625 17.375L12.625 8.875"
        stroke="#666666"
        stroke-width="1.5"
        class="stroke"
      />
      <path
        d="M6.9585 7.45831L9.79183 7.45831"
        stroke="#666666"
        stroke-width="1.5"
        stroke-linecap="round"
        class="stroke"
      />
      <path
        d="M7.6665 10.2917H6.95817"
        stroke="#666666"
        stroke-width="1.5"
        stroke-linecap="round"
        class="stroke"
      />
      <path
        d="M6.9585 13.125L9.0835 13.125"
        stroke="#666666"
        stroke-width="1.5"
        stroke-linecap="round"
        class="stroke"
      />
    </g>
  </svg>
</template>
<style lang="scss" scoped>
.v-list-item--active svg .fill {
  fill: #df252a;
}
.v-list-item--active svg .stroke {
  stroke: #df252a;
}
</style>
